import { Phone, Mail, MapPin } from "lucide-react";
import { BRAND, NAV_LINKS, scrollToId } from "./data";
import { LogoMark } from "./LogoMark";

const scrollTo = (id) => scrollToId(id);

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative pt-24 pb-10 px-5 border-t hairline overflow-hidden"
      style={{ background: "var(--footer-bg)" }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <LogoMark variant="icon" className="w-11 h-11" />
              <div>
                <p className="font-heading font-extrabold text-xl txt-primary">{BRAND.name}</p>
                <p className="font-mono text-[10px] tracking-[0.25em] uppercase overline">
                  {BRAND.suffix}
                </p>
              </div>
            </div>
            <p className="mt-5 txt-soft max-w-sm leading-relaxed">
              High-octane mobile, web, and cloud apps engineered in Canada for
              every platform.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-xs tracking-[0.2em] uppercase txt-dim mb-4">Navigate</p>
            <ul className="space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button data-testid={`footer-link-${l.id}`} onClick={() => scrollTo(l.id)} className="txt-soft hover:txt-primary transition-colors">
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono text-xs tracking-[0.2em] uppercase txt-dim mb-4">Get in touch</p>
            <ul className="space-y-3">
              <li>
                <a href={`tel:${BRAND.phoneTel}`} data-testid="footer-phone" className="flex items-center gap-2.5 txt-soft hover:txt-primary transition-colors">
                  <Phone className="w-4 h-4 text-indigo-400" /> {BRAND.phoneDisplay}
                </a>
              </li>
              <li>
                <a href={`mailto:${BRAND.email}`} data-testid="footer-email" className="flex items-center gap-2.5 txt-soft hover:txt-primary transition-colors break-all">
                  <Mail className="w-4 h-4 text-indigo-400" /> {BRAND.email}
                </a>
              </li>
              <li className="flex items-center gap-2.5 txt-soft">
                <MapPin className="w-4 h-4 text-indigo-400" /> {BRAND.location}
              </li>
            </ul>
          </div>
        </div>

        <div className="relative select-none pointer-events-none py-6">
          <h2 className="font-heading font-extrabold text-outline text-center leading-none" style={{ fontSize: "clamp(3rem, 16vw, 15rem)" }}>
            BRAINSTEM
          </h2>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 border-t hairline">
          <p className="text-sm txt-dim">
            © {new Date().getFullYear()} Brainstem App Solutions. All rights reserved.
          </p>
          <p className="flex items-center gap-2 text-sm txt-soft">
            <span className="text-red-500">🍁</span> Engineered in Canada
          </p>
        </div>
      </div>
    </footer>
  );
};
